var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTravelPlansSmallHomeStream(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTravelPlansSmallHomeStream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.6771276,19.3527506 C28.633963,19.0297515 28.7850392,18.5990859 29.0224446,18.3622198 L29.8209901,17.6085551 L31.8713097,15.6920932 C31.892892,15.67056 31.9144743,15.6490267 31.9360566,15.6274934 C32.5403613,14.981495 32.7777668,13.5818319 32.0439682,12.892767 C31.3317519,12.2037021 29.9289017,12.505168 29.324597,13.1511664 L26.6483904,16.0366257 C26.4325672,16.2734918 25.9793387,16.4242247 25.655604,16.3811582 L14.346473,14.7661623 C14.0227383,14.7230957 13.5910921,14.8953619 13.3968513,15.132228 L12.6198881,16.0796923 C12.4040649,16.3380916 12.4903942,16.6180242 12.7925465,16.7472239 L21.9866111,20.2356151 C22.2887635,20.3432815 22.3535104,20.6447474 22.1376873,20.8816134 L18.1881244,25.0806028 C18.1449597,25.1021361 18.0802128,25.1021361 18.0370482,25.1021361 L13.6126744,25.1452026 C13.4400159,25.1452026 13.2889397,25.2744023 13.2673574,25.4466685 L13.0515343,26.5448658 C13.029952,26.6955987 13.1162812,26.8893982 13.2673574,26.9324648 L16.5047041,28.1383284 C16.6557803,28.2029282 16.8284387,28.3751945 16.8716034,28.5259274 L18.0802128,31.7559192 C18.1449597,31.9066522 18.3176182,32.0143186 18.4686944,31.971252 L19.5693923,31.7559192 C19.7204685,31.734386 19.8499623,31.5621197 19.8715446,31.4113868 L19.9147093,26.9755313 C19.9147093,26.9324648 19.9147093,26.8893982 19.9362916,26.8247984 L22.3103458,24.6068707 L24.1664246,22.8626751 C24.40383,22.6473423 24.6844,22.7119421 24.8138939,23.013408 L28.3102283,32.2081181 C28.4181399,32.509584 28.7202922,32.5957171 28.97928,32.3803843 L29.9289017,31.6051863 C30.1663071,31.4113868 30.3389656,30.9807212 30.295801,30.657722 L28.6771276,19.3527506 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-28.5%",
    y: "-30.0%",
    width: "158.5%",
    height: "159.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.658967391 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travel",
    transform: "translate(-274.000000, -540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-12",
    transform: "translate(265.000000, 531.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icTravelPlansSmallHomeStream"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravelPlansSmallHomeStream);
export default __webpack_public_path__ + "static/media/icTravelPlansSmallHomeStream.aa09c86c3abc8af59e82cbe62067e1a9.svg";
export { ForwardRef as ReactComponent };